import React, { useState, useEffect } from "react"
import {
  Card,
  Button,
  Input,
  Table,
  Select,
  Dropdown,
  Icon,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"

const EditingTerminal = (props) => {
  const { t } = useTranslation()
  const {
    terminal,
    place,
    setPlace,
    name,
    setName,
    line,
    setLine,
    mode,
    setMode,
    storage,
    setStorage,
    handleSubmit,
    getTerminals,
    lines,
  } = props
  useEffect(() => {
    return () => {}
  }, [])
  return (
    <>
      <div>
        <h3>
          <b>{t("Editing device")}</b>
        </h3>
        <div style={{ margin: 20 }}>
          <div>
            <div>{t("Name")}</div>
            <div>
              <Input
                placeholder={terminal.name}
                value={name}
                onChange={(e, d) => {
                  setName(d.value)
                }}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div style={{ display: "none" }}>
            <div>Режим работы устройства</div>
            <div>
              <Input
                placeholder={terminal.mode}
                value={mode}
                onChange={(e, d) => {
                  setMode(d.value)
                }}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div style={{ display: "none" }}>
            <div>{t("Line")}</div>
            <div>
              <Select
                placeholder={terminal.line}
                value={line}
                options={lines.map((q) => ({
                  key: q.id,
                  value: q.id,
                  text: q.name,
                }))}
                onChange={(e, d) => {
                  setLine(d.value)
                }}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div style={{ display: "none" }}>
            <div>Рабочее место</div>
            <div>
              <Input
                placeholder={terminal.place}
                value={place}
                type="number"
                onChange={(e, d) => {
                  setPlace(d.value)
                }}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div style={{ display: "none" }}>
            <div>Склад</div>
            <div>
              <Input
                placeholder={terminal.storage}
                value={storage}
                onChange={(e, d) => {
                  setStorage(d.value)
                }}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div>
            <Button
              content={t("Save")}
              positive
              style={{ marginTop: 30 }}
              onClick={handleSubmit}
              disabled={false}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default EditingTerminal
